import PriceInputComponent from "./PriceInputComponent";

export default PriceInputComponent;
